(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/test-tracking-utils.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/test-tracking-utils.js');
"use strict";

const testTrackingUtils = () => {
  let trackEventSpy;
  let trackTransactionSpy;
  const beforeEachStubs = () => {
    trackEventSpy = sinon.spy(svs.components.analytics, 'trackEvent');
    trackTransactionSpy = sinon.spy(svs.components.analytics, 'trackTransaction');
    return {
      trackEventSpy,
      trackTransactionSpy
    };
  };
  const afterEachStubs = () => {
    trackEventSpy.restore();
    trackTransactionSpy.restore();
    trackTransactionSpy.restore();
  };
  const shouldTrackValidateManualValidation = expectedOptLabel => {
    should(trackEventSpy.calledWithExactly({
      category: 'validate_ticket',
      action: 'manual-validation',
      opt_label: expectedOptLabel,
      opt_value: 0 
    })).eql(true, 'Manual validation should be tracked');
  };
  const shouldTrackValidateQRCodeFailure = expectedOptLabel => {
    should(trackEventSpy.calledWithExactly({
      category: 'validate_ticket',
      action: 'qr-code-failure',
      opt_label: expectedOptLabel,
      opt_value: 0 
    })).eql(true, 'QR code failure should be tracked');
  };
  const shouldTrackValidateQRCodeSuccess = expectedOptLabel => {
    should(trackEventSpy.calledWithExactly({
      category: 'validate_ticket',
      action: 'qr-code',
      opt_label: expectedOptLabel,
      opt_value: 0 
    })).eql(true, 'QR code success should be tracked');
  };
  const shouldTrackValidateQRCodeButton = (expectedOptLabel, expectedButtonText) => {
    should(trackEventSpy.calledWithExactly({
      category: 'validate_ticket',
      action: "qr-code-".concat(expectedButtonText),
      opt_label: expectedOptLabel,
      opt_value: 0 
    })).eql(true, 'QR code button should be tracked');
  };
  const shouldTrackValidateOneTimePassword = expectedOptLabel => {
    should(trackEventSpy.calledWithExactly({
      category: 'validate_ticket',
      action: 'scratch_ticket_validation',
      opt_label: expectedOptLabel,
      opt_value: 0 
    })).eql(true, 'One time password should be tracked');
  };
  const shouldTrackValidateWithdrawal = expectedOptLabel => {
    should(trackEventSpy.calledWithExactly({
      category: 'validate_ticket',
      action: 'withdrawal_ticket',
      opt_label: expectedOptLabel,
      opt_value: 0 
    })).eql(true, 'Withdrawal should be tracked');
  };
  const shouldTrackValidateBuyNewTicketsOnlineChosen = expectedOptLabel => {
    should(trackEventSpy.calledWithExactly({
      category: 'validate_ticket',
      action: 'new_ticket_online',
      opt_label: expectedOptLabel,
      opt_value: 0 
    })).eql(true, 'Buy new ticket online should be tracked');
  };
  const shouldTrackValidateBuyNewTicketsOfflineChosen = expectedOptLabel => {
    should(trackEventSpy.calledWithExactly({
      category: 'validate_ticket',
      action: 'new_ticket_offline',
      opt_label: expectedOptLabel,
      opt_value: 0 
    })).eql(true, 'Buy new ticket offline should be tracked');
  };
  const shouldTrackValidateKeepWinChosen = type => {
    should(trackEventSpy.calledWithExactly({
      category: 'validate_ticket',
      action: 'ticket_win_save',
      opt_label: type,
      opt_value: 0 
    })).eql(true, 'Keep win chosen should be tracked');
  };
  const shouldTrackValidatedTicketResult = (type, win) => {
    should(trackEventSpy.calledWithExactly({
      category: 'validate_ticket',
      action: win ? 'ticket_win' : 'ticket_lose',
      opt_label: type,
      opt_value: 0 
    })).eql(true, 'Validated ticket result should be tracked');
  };
  const shouldTrackValidateVoucherRedeemPurchase = (type, buttonText) => {
    should(trackEventSpy.calledWithExactly({
      category: 'Voucher redeem',
      action: "".concat(buttonText, "-purchase"),
      opt_label: type || 'undefined',
      opt_value: 0 
    })).eql(true, 'Voucher redeem purchase should be tracked');
  };
  const shouldTrackValidateQualtrics = function () {
    let {
      numberOfTicketsPurchased,
      winAmountValidatedTicket,
      winAmountNewTicket = 0
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    should(trackEventSpy.calledWithExactly({
      category: 'valideraQualtrics',
      action: numberOfTicketsPurchased,
      opt_label: winAmountValidatedTicket,
      opt_value: winAmountNewTicket
    })).eql(true, 'Qualtrics-event should be tracked');
  };
  const shouldTrackOrderHomeDividerOrderHomeSelected = () => {
    should(trackEventSpy.calledWithExactly({
      category: 'Triss_postbox',
      action: 'Order_home',
      opt_value: 0 
    })).eql(true, 'Order home divider, order home selected should be tracked');
  };
  const shouldTrackOrderHomeDividerSubscribeSelected = () => {
    should(trackEventSpy.calledWithExactly({
      category: 'Triss_postbox',
      action: 'Subscribe',
      opt_value: 0 
    })).eql(true, 'Order home divider, subscribe selected should be tracked');
  };
  const shouldTrackOrderHomeCartSelections = (expectedOptLabel, totalNumberOfItems) => {
    should(trackEventSpy.calledWithExactly({
      category: 'Triss_postbox',
      action: 'select_orderhome',
      opt_label: expectedOptLabel,
      opt_value: totalNumberOfItems
    })).eql(true, 'Order home cart selections should be tracked');
  };
  const shouldTrackOrderHomeCartTicketCountChange = (productName, countChange) => {
    const action = countChange > 0 ? 'addPostbox' : 'removePostbox';
    should(trackEventSpy.lastCall.firstArg).eql({
      category: 'Triss_postbox',
      action,
      opt_label: productName,
      opt_value: 0 
    });
  };
  const shouldTrackOrderHomeBuyTicketClick = reciver => {
    should(trackEventSpy.calledWithExactly({
      category: 'Triss_postbox',
      action: 'postboxMoreTicket',
      opt_label: reciver,
      opt_value: 0 
    })).eql(true, 'Order home buy ticket click should be tracked');
  };
  const shouldTrackPurchaseTransactions = _ref => {
    let {
      productName,
      totalAmount = '0',
      shippingAmount = '0',
      taxAmount = '0',
      orderId,
      items = []
    } = _ref;
    should(trackTransactionSpy.calledWith({
      affiliation: '.se',
      items,
      orderId,
      productName,
      shippingAmount: parseFloat(shippingAmount).toFixed(2),
      taxAmount: parseFloat(taxAmount).toFixed(2),
      totalAmount: parseFloat(totalAmount).toFixed(2)
    })).eql(true, 'Should track purchase transactions');
  };
  return {
    beforeEachStubs,
    afterEachStubs,
    shouldTrackValidateManualValidation,
    shouldTrackValidateQRCodeFailure,
    shouldTrackValidateQRCodeSuccess,
    shouldTrackValidateQRCodeButton,
    shouldTrackValidateOneTimePassword,
    shouldTrackValidateWithdrawal,
    shouldTrackValidateBuyNewTicketsOnlineChosen,
    shouldTrackValidateBuyNewTicketsOfflineChosen,
    shouldTrackValidateKeepWinChosen,
    shouldTrackValidateVoucherRedeemPurchase,
    shouldTrackValidatedTicketResult,
    shouldTrackValidateQualtrics,
    shouldTrackOrderHomeDividerOrderHomeSelected,
    shouldTrackOrderHomeDividerSubscribeSelected,
    shouldTrackOrderHomeCartSelections,
    shouldTrackOrderHomeCartTicketCountChange,
    shouldTrackOrderHomeBuyTicketClick,
    shouldTrackPurchaseTransactions
  };
};
setGlobal('svs.ticketgames.ticketUtility.testTrackingUtils', testTrackingUtils);

 })(window);